
import Vue from 'vue';

export default Vue.extend({
  name: 'App',

  data: () => ({
  }),
  beforeCreate() {
    this.$store.dispatch("initCart");
    this.$store.dispatch("initFilter");
  }
});
